import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { GoalService } from 'projects/ey-nav-web-components/src';
import { BaseRouteConfigService } from '@EYN/lib';
import { first } from 'rxjs/operators';

// TODO: Review the application of this guard. Feels like this is not needed since we merged all goals in one SPA
@Injectable()
export class BreadcrumbGuard implements CanActivate {

	constructor(private goalService: GoalService,
				private baseRouteConfig: BaseRouteConfigService,
	) {
	}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		this.baseRouteConfig.data
			.pipe(first())
			.subscribe(({ overviewRoute }) => {
				const copy = Object.assign({}, route.parent.data);
				delete copy['breadcrumbUrl'];
				route.parent.data = copy;
			});

		return true;
	}
}
